import React, { useState, useEffect, useContext, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { withStyles } from '@material-ui/core/styles'
import { Route, Link as RouterLink, withRouter } from 'react-router-dom'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import contentBlockMaps from '../contentblocks'
import sectionMaps from '../sections'

const styles = theme => ({
  root: {
//    maxWidth: 480,
//    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {
  },
  divider: {
    width: '100%',
    height: theme.spacing.unit,
//    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  }
})

const PageBase = ({ classes, theme, history, data, lastFetched, newSectionMaps, newContentBlockMaps, renderHelmet, renderSections }) => {

  const [initialized, setInitialized] = useState(false);

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))
  
  const topElement = useRef()

  /*
  useEffect(() => {
    navigationContext.setLoading(isFetching)
    
    return () => {
      navigationContext.setLoading(false)
    }
  }, [isFetching])
  */
  
  const internalOpenLink = (linkTo) => {
    let link = ""
    
    if (linkTo.startsWith("#")) {
      // Scroll to section.
//      alert(linkTo)
//      window.location = linkTo
//      window.location.hash = linkTo //linkTo.substring(1)
      const id = linkTo.substring(1)
      const element = document.getElementById(id);
      if (element) 
        element.scrollIntoView({behavior: 'smooth'});
      return
    }
    
    if (linkTo.startsWith("mailto:")) {
      window.location.href = linkTo
      return
    }

    // if (openLink){
    //   openLink(linkTo)
    // }

    if (linkTo.startsWith("/"))
      link = linkTo
    else
      link = "/" + linkTo

    if (link === "/home")
      link = "/"

    history.push(link)

  }

  const createContentBlock = (componentName, contentData, index, params={}) => {
    let comp
    // Don't know why this doesn't return 'function' for component
    // if (typeof componentName === 'function')
    if (componentName && typeof componentName != 'string')
        comp = componentName
    else if (newContentBlockMaps && componentName in newContentBlockMaps)
        comp = newContentBlockMaps[componentName]
    else if (componentName in contentBlockMaps)
        comp = contentBlockMaps[componentName]
    else
        comp = contentBlockMaps['TitleContentBlock'] // default:
        
    return React.createElement(comp, {
      ...contentData,
      itemKey: contentData.key,
      openLink: internalOpenLink,
      contentIndex: index,
      ...params
      })
  }
  
  const createSection = (sectionData, index, params={}) => {
    let comp
    // Don't know why this doesn't return 'function' for component
    // if (typeof sectionData.component === 'function')
    if (sectionData.component && typeof sectionData.component != 'string')
        comp = sectionData.component    
    else if (newSectionMaps && sectionData.component in newSectionMaps)
        comp = newSectionMaps[sectionData.component]
    else if (sectionData.component in sectionMaps)
        comp = sectionMaps[sectionData.component]
    else
        comp = sectionMaps['TitleSection'] // default:

    let spacing
    if(smUp){
      spacing = 1
    }else{
      spacing = 2
    }
        
    return React.createElement(comp, {
      ...sectionData,
      item_spacing: 'item_spacing' in sectionData ? sectionData.item_spacing : spacing,
      horizontal_alignment: 'horizontal_alignment' in sectionData ? sectionData.horizontal_alignment.value : 'center',
      vertical_alignment: 'vertical_alignment' in sectionData ? sectionData.vertical_alignment.value : 'center',
      color_mode: 'color_mode' in sectionData ? sectionData.color_mode.value : 'light',
      color: 'color' in sectionData ? sectionData.color.value : 'white',
      item_size: 'item_size' in sectionData ? sectionData.item_size.value : 'medium',
      text_alignment: 'text_alignment' in sectionData ? sectionData.text_alignment.value : 'center',
      item_text_alignment: 'item_text_alignment' in sectionData ? sectionData.item_text_alignment.value : 'center',
      item_image_position: 'item_image_position' in sectionData ? sectionData.item_image_position.value : undefined,
      item_image_alternate_position: 'item_image_alternate_position' in sectionData ? sectionData.item_image_alternate_position.value : undefined,
      item_button_style: 'item_button_style' in sectionData ? (sectionData.item_button_style.value != null ? sectionData.item_button_style.value : 'medium') : 'medium',
      button_style: 'button_style' in sectionData ? (sectionData.button_style.value != null ? sectionData.button_style.value : 'medium') : 'medium',
      section_width: 'section_width' in sectionData ? (sectionData.section_width.value != null ? sectionData.section_width.value : 'full') : 'full',
      section_height: 'section_height' in sectionData ? (sectionData.section_height != null ? sectionData.section_height : 66) : 66,
      hashKey: sectionData.key,
      openLink: internalOpenLink,
      sectionIndex: index,
      key: index.toString(),
      createContentBlock: createContentBlock,
      ...params
      })
  }
  
  let sections = null
  if (lastFetched) {
    const divider = (<div className={classes.divider} />)
    if (renderSections)
      sections = renderSections({
        createSection,
        createContentBlock,
        openLink: internalOpenLink,
        pageData: data,
        divider: divider
        })
    else
      sections = data.sections !== undefined && data.sections.length > 0 && data.sections.map((sectionData, index) => 
          createSection(sectionData, index)
        )
        .reduce((prev, next) => [prev, divider, next])
  }
  
  let helmet = null
  if (lastFetched)
    if (renderHelmet)
      helmet = renderHelmet({pageData: data})
    else
      helmet = (
        <>
          <title>{ data.title || data.name } - { process.env.REACT_APP_TITLE_SUFFIX }</title>
        </>
      )
  
  return (
    <div>
      { helmet &&        
        <Helmet>
          { helmet.children }
        </Helmet>
      }
      <div className={classes.root} ref={topElement}>
        <div className={classes.content}>
          { sections }
        </div>
      </div>
    </div>
    )

}

function popupLinkFromProps(props) {
  let link = null
/*
  if (props.match) {
    if (props.match.params.storyKey !== undefined)
      link = "story/" + props.match.params.storyKey
    else if (props.match.params.productKey !== undefined)
      link = "product/" + props.match.params.productKey
  }
*/
  return link
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    (PageBase)
  )
)